import React from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import { stopSubmit, formValueSelector } from 'redux-form'
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import DateRangeIcon from 'material-ui/svg-icons/action/date-range';
import * as colors from 'material-ui/styles/colors';

import * as commons from '../../../commons';

import moment from 'moment'

import PageBase from '../../../components/PageBase';
import DataTables from '../../../components/DataTables/DataTables'

import listHeader from './listHeader'
import gStyles from '../../../styles'

import OverTimeMasterForm from './OverTimeMasterForm'

import * as actions from '../../../actions'

const MASTER_TYPE = "overTime"

const validate = values => {
  const errors = {}
  const requiredFields = [
    // "branchOfficeId",
    // "departmentId",
    "date",
    "startTime",
    "endTime",
    "comment",
  ]

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })


  if (values.startTime) {
      values.startTime = values.startTime.replace(/[０-９：]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
  }

  if (values.endTime) {
      values.endTime = values.endTime.replace(/[０-９：]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
  }

  if (values.startTime) {
    
      if (values.startTime.indexOf(':') == -1) {
        if (values.startTime.length == 3) {
          values.startTime = values.startTime.slice(0, 1) + ':' + values.startTime.slice(1, values.startTime.length)
        } else if (values.startTime.length == 4) {
          values.startTime = values.startTime.slice(0, 2) + ':' + values.startTime.slice(2, values.startTime.length)
        }
      }

      if (!commons.validateTime(values.startTime)){
        errors.startTime = '時刻が不正です。(例：10:00)'
      }
  }

  if (values.endTime) {

    if (values.endTime.indexOf(':') == -1) {
      if (values.endTime.length == 3) {
        values.endTime = values.endTime.slice(0, 1) + ':' + values.endTime.slice(1, values.endTime.length)
      } else if (values.endTime.length == 4) {
        values.endTime = values.endTime.slice(0, 2) + ':' + values.endTime.slice(2, values.endTime.length)
      }
    }

    if (!commons.validateTime(values.endTime)){
      errors.endTime = '時刻が不正です。(例：10:00)'
    }
  }

  if (values.startTime && values.endTime) {
      if (
          commons.validateTime(values.startTime) &&
          commons.validateTime(values.endTime) &&
          (commons.toTimeNumber(values.startTime) > commons.toTimeNumber(values.endTime))) {
          errors.startTime = '時刻間隔が不正です。'
          errors.endTime = '時刻間隔が不正です。'
      }
  }

  return errors
}

const validateSearch = values => {
  const errors = {}
  return errors
}

class OverTimeMasterPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      open: false
    }
  }

  componentDidMount() {
    const {
      form,
      page
    } = this.props

    this.props.handleInit(form, page)
  }


  handlePreviousPageClick(form, page, editIndex) {

    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }
    const prevPage = page - 1
    this.props.handlePageClick(prevPage, form)
  }

  handleNextPageClick(form, page, editIndex) {

    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }
    const nextPage = page + 1
    this.props.handlePageClick(nextPage, form)
  }

  handleConfirmOpen(id, item) {
    this.setState(Object.assign({}, this.state, {
      id: id,
      item: item,
      open: true
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  }

  handlePageReset() { 
    this.setState(Object.assign({}, this.state, {
      page: 1
    }))
  }

  getEndTime(startTime, endTime) {

    if (startTime.format('yyyyMMdd') !== endTime.format('yyyyMMdd')) {
      const h = endTime.format('HH');
      const m = endTime.format('mm');
      return (Number(h) + 24) + ":" + m;
    }

    return endTime.format('HH:mm');
  }

  render() {

    const {
      auth,
      selectData,
      selectedBranchOfficeId,
      handleFormSearchClick,
      handleFormRegistClick,
      handleFormEditClick,
      handleFormDeleteClick,
      handleFormResetClick,
      handleLocalStorageSave,
      tmpForm,
      history
    } = this.props

    const page = this.props.page
    const count = this.props.count
    const form = this.props.form || {}
    const list = this.props.list || []

    let editIndex;
    const dataList = list.map((x, index) => {

      const actions = (
        ((x.userId == auth.user.id) || (auth.user.permission == 2)) && <div style={{display: "flex", justifyContent: 'flex-end'}}>
          <div style={{ margin: '10px 10px' }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} onTouchTap={!form.id && handleFormEditClick(x.id)} disabled={form.id ? true : false}>
              <ContentCreate />
            </FloatingActionButton>
          </div>
          <div style={{ margin: '10px 10px' }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.red300}
                                  onTouchTap={!form.id && this.handleConfirmOpen.bind(this,x.id, x.work)} disabled={form.id ? true : false}
            >
              <ContentRemove />
            </FloatingActionButton>
          </div>
        </div>
      )

      if (form.id == x.id) {
        editIndex = index
      }

      const startTimeMoment = moment(x.startTime, 'YYYY/MM/DD HH:mm:ss')
      const endTimeMoment = moment(x.endTime, 'YYYY/MM/DD HH:mm:ss')

      const startTime =  startTimeMoment.format('HH:mm')
      const endTime =  this.getEndTime(startTimeMoment, endTimeMoment)

      return {
        branchOfficeName: x.branchOfficeName,
        departmentName: x.departmentName,
        overDate: x.date + ' ' + startTime + ' - ' + endTime,
        comment: x.comment,
        userName: x.userName,
        actions: actions,
      }

    })

    const dialogActions = [
      <FlatButton
        label="キャンセル"
        primary={true}
        onTouchTap={this.handleConfirmClose.bind(this)}
      />,
      <FlatButton
        label="削除"
        primary={true}
        keyboardFocused={true}
        onTouchTap={handleFormDeleteClick(this.state.id, page, this.handleConfirmClose.bind(this), form)}
      />,
    ];

    const editColor = form.id && {backgroundColor: colors.lightGreen50}

    return (

      <PageBase title="残業申請" >

        <div>

          <div style={gStyles.searchBoxContainer}>

            <Paper style={{...gStyles.contentsPaper, ...editColor}}>
              <OverTimeMasterForm 
                auth={auth}
                selectedBranchOfficeId={selectedBranchOfficeId}
                branchOfficeData={selectData.branchOffice}
                departmentData={selectData.department}
                priceData={selectData.price}
                onFormRegistClick={handleFormRegistClick(form.id, page, tmpForm, auth.user.id)}
                onFormResetClick={handleFormResetClick}
                onFormSearchClick={handleFormSearchClick(this.handlePageReset.bind(this))}
                initialValues={form}
                onLocalStorageSave={handleLocalStorageSave}
              />
            </Paper>

          </div>

          <Paper style={{...gStyles.contentsPaper}}>
            <DataTables
              editIndex={editIndex}
              tableStyle={{overflow: 'hidden', tableLayout: ''}}
              tableBodyStyle={{overflowX: 'auto'}}
              height={'auto'}
              showRowHover={true}
              columns={listHeader}
              data={dataList}
              page={page}
              showRowSizeControls={false}
              onNextPageClick={this.handleNextPageClick.bind(this, form, page, editIndex)}
              onPreviousPageClick={this.handlePreviousPageClick.bind(this, form, page, editIndex)}
              count={count}
            />
          </Paper>

        </div>


        <Dialog
          title="残業申請"
          actions={dialogActions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleConfirmClose.bind(this)}
        >
          {this.state.item} を削除します。よろしいですか？
        </Dialog>

      </PageBase>

    )
  }

}

const selector = formValueSelector(`${MASTER_TYPE}MasterForm`)
const mapStateToProps = (state) => ({
  auth: state.auth,
  list: state.master.list[MASTER_TYPE] ,
  count: state.master.count[MASTER_TYPE],
  form: state.master.form[MASTER_TYPE],
  page: state.master.page[MASTER_TYPE],
  tmpForm: state.master.tmpForm[MASTER_TYPE],
  selectData: state.master.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId'),
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : (form, page) => {dispatch(actions.systemMasterInit(MASTER_TYPE, form, page))},
  handleFormEditClick : (id) => () => {
    dispatch(reset(`${MASTER_TYPE}MasterForm`));
    dispatch(actions.userMasterFormEdit(MASTER_TYPE, id))
  },
  handleFormDeleteClick : (id, page, close, form) => () => {
    close()
    dispatch(actions.userMasterFormDelete(MASTER_TYPE, id, page, form))
  },
  handleFormResetClick : () => {dispatch(actions.reducerMasterFormReset(MASTER_TYPE))},

  handleFormRegistClick : (id, page, form, userId) => (values) => {
    const errors = validate(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }

    const newForm = Object.assign({}, values, {
      userId: userId,
      date: moment(values.date).format('YYYY-MM-DD')
    })

    dispatch(actions.userMasterFormRegist(MASTER_TYPE, id, newForm, page, form))
  },
  handleFormSearchClick : (pageReset) => (values) => {
    const errors = validateSearch(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    pageReset()

    const newForm = Object.assign({}, values, {
      date: values.date ? moment(values.date).format('YYYY-MM-DD') : values.date
    })

    dispatch(actions.userMasterSearch(MASTER_TYPE, 1, newForm))
  },
  handlePageClick : (page, form) => {
    dispatch(actions.userMasterSearch(MASTER_TYPE, page, form))
  },
  handleLocalStorageSave : (values) => {
    if (!window.localStorage) {
      window.alert('お使いのブラウザでは固定できません。他のブラウザを使用して下さい。')
      return
    }
    window.localStorage.setItem(MASTER_TYPE, JSON.stringify(values))
    dispatch(actions.reducerSnackBar(true, '入力値を固定しました。', colors.green400))
  },
})

OverTimeMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(OverTimeMasterPage)

export default OverTimeMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/overTime/OverTimeMasterPage.js